import { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import ReactCodeInput from 'react-code-input';
import { renderIcon } from '@/utils/iconRenderer';
import { t } from 'i18next';
import useAppApi from '@/services/api/setUserApi';
import SetUserApi from '@/services/api/setUserApi';
import useAuth from '@/features/hooks/useAuth';
import useMessage from '@/features/hooks/useMessage';

export default function VerifyCode() {
  const [otp, setOtp] = useState('');
  const [errorMessage, setErrorMessage] = useState(''); // Uyarı mesajı için state
  const { state } = useLocation();
  const userName = state?.userName || '';
  const phoneLoginFL = state?.phoneLoginFL || false;
  const { VerifyCode } = useAppApi();
  const navigate = useNavigate();
  const { LoginPhone } = SetUserApi();
  const { loginByPhone } = useAuth();
  const { messageBox } = useMessage();

  const handleVerify = async () => {
    if (!otp || otp.length < 6) {
      setErrorMessage(t('Lutfen6HaneliDogrulamaKodunuGiriniz')); // Hata mesajı güncelleniyor
      return;
    }

    setErrorMessage(''); // Başarılı giriş denemesinde hata mesajını temizle

    if (phoneLoginFL) {
      const response = await LoginPhone({ Phone: userName, Code: otp });

      if (response) {
        try {
          await loginByPhone(response.data.token);
          navigate('/');
        } catch (error) {
          console.error('Apple login failed', error);
        }
      }
    } else {
      const response = await VerifyCode({ UserName: userName, Code: otp });
      if (response.success) {
        navigate('/auth/reset-password', { state: { userName, otp } });
      } else {
        messageBox(response?.message, 'error', 500);
      }
    }
    setErrorMessage('');
  };

  const handleChange = (value) => {
    setOtp(value);
    if (errorMessage) setErrorMessage(''); // Kullanıcı yazarken hata mesajını temizle
  };

  const inputStyle = {
    fontFamily: 'monospace',
    MozAppearance: 'textfield',
    borderRadius: '5px',
    border: '1px solid #ccc',
    margin: '2px',
    paddingLeft: '8px',
    width: '40px',
    height: '40px',
    fontSize: '18px',
    fontWeight: 'bold',
    textAlign: 'center',
    outline: 'none',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.2)'
  };

  const focusStyle = {
    borderColor: '#6366F1',
    boxShadow: '0 0 5px rgba(99, 102, 241, 0.5)'
  };

  return (
    <div className="container mx-auto px-2 lg:px-0 flex justify-center items-center min-h-screen">
      <div id="card" className="card lg:w-[30%] shadow-1xl ">
        <div
          id="card-title"
          className="flex flex-row items-center justify-start justify-align-content-between  text-success-500 bg-color-header-menu gap-2 p-3 border ">
          {renderIcon('verified-user', 28, 'text-gray-100')}
          <p className="ml-2 text-color-text-white text-lg font-semibold">
            {t('ConfirmPassword')}
          </p>
        </div>

        <div id="card-body" className="border p-1 ">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleVerify();
            }}
            className="space-y-6">
            <p className="text-center my-2 text-gray-700">
              {t('LutfenSizeGonderilenDogrulamaKodunuGirin')}
            </p>

            {/* Uyarı Mesajı */}
            {errorMessage && (
              <p className="alert alert-danger text-center my-2 bg-red-100 text-red-700 p-0 rounded">
                {errorMessage}
              </p>
            )}

            {/* Doğrulama Kodu Girişi */}
            <div className="flex justify-center items-center">
              <ReactCodeInput
                type="number"
                className="my-1 text-color-text"
                fields={6}
                value={otp}
                onChange={handleChange}
                inputStyle={inputStyle}
                focusStyle={focusStyle}
                placeholder="0"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>

            <div className="flex justify-start gap-2 m-2">
              <Link
                to="/auth/login"
                className=" bg-color-button text-white px-2 py-2  shadow hover:bg-color-button-hover rounded transition-colors duration-300">
                {renderIcon('home', 28, 'text-white')}
              </Link>
              <button
                className="flex items-center justify-center bg-color-button text-white w-full py-2  shadow hover:bg-color-button-hover rounded transition-colors duration-300"
                type="submit">
                {renderIcon('domain-verification', 28, 'text-white')}
                <p className="text-sm px-1">{t('Confirm')}</p>
              </button>
            </div>
          </form>
        </div>

        <div
          id="card-footer"
          className="flex justify-start items-center mt-2 border-t  border-gray-300 p-2"></div>
      </div>
    </div>
  );
}
